<template>
  <div>
    <el-dialog title="Refund Detail" :close-on-click-modal="false" :visible.sync="visible" width="1200px" top="3vh">
      <el-form ref="dataForm" autocomplete="off" label-position="top" v-loading="loading">
        <el-row :gutter="10" class="pb10">
          <el-col :span="24">
            <el-form-item label="Refund Items">
              <el-table :data="detail?.statusDetail?.refundInfoList || []" size="medium" border class="wdb100">
                <el-table-column label="Description" prop="orderDescription" align="center" />
                <el-table-column label="Gov Fee" align="center" width="120">
                  <template slot-scope="scope">
                    <p class="orange">{{ currencyAndAmountFormat(billingCurrency(scope.row.bankAccountIds), scope.row.deductionAcraFee) }}</p>
                  </template>
                </el-table-column>
                <el-table-column label="Handling Fee" align="center" width="120">
                  <template slot-scope="scope">
                    <p class="orange">{{ currencyAndAmountFormat(billingCurrency(scope.row.bankAccountIds), scope.row.deductionHandlingFee) }}</p>
                  </template>
                </el-table-column>
                <el-table-column label="Invoice Template" align="center">
                  <template slot-scope="scope">
                    <p>{{ invoiceTemplate(scope.row.invoiceTemplateId) }}</p>
                  </template>
                </el-table-column>
                <el-table-column label="Bank Accounts" align="center">
                  <template slot-scope="scope">
                    <p>{{ bankAccountList(scope.row.bankAccountIds) }}</p>
                  </template>
                </el-table-column>
                <el-table-column label="Apply Reason" prop="applyReason" align="center" />
              </el-table>
            </el-form-item>
          </el-col>

          <el-col :span="24" v-if="detail?.statusDetail?.remark">
            <el-form-item label="Remark">
              <p class="m0 lh22">{{ detail.statusDetail.remark }}</p>
            </el-form-item>
          </el-col>
          <el-col :span="24" v-if="detail?.statusDetail?.attachmentUrls?.length > 0">
            <el-form-item label="Attachments">
              <p v-for="(item, idx) in detail.statusDetail.attachmentUrls" :key="`attachmentUrls${idx}`" class="fs13 m0 lh26">
                <a :href="item.url" target="_blank">{{ item.name }}</a>
              </p>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
    </el-dialog>
  </div>
</template>

<script>
import formatterMixin from "@/mixins/formatterMixin";
export default {
  mixins: [formatterMixin],
  props: {
    detail: {
      type: Object,
      default: () => {},
    },
  },
  data() {
    return {
      visible: false,
      invoiceTemplateList: [],
      supplierBankAccountList: [],
      loading: false,
    };
  },
  methods: {
    // 初始化
    async init() {
      this.loading = true;
      this.visible = true;
      await this.$nextTick();
      this.$refs["dataForm"].resetFields();
      await this.getInvoiceTemplateList();
      await this.getSupplierBankAccountList();
      this.loading = false;
    },
    // 获取发票模板列表
    getInvoiceTemplateList() {
      return new Promise((resolve, reject) => {
        this.$http
          .get("/admin/invoiceTemplate")
          .then(res => {
            const resData = res.data || [];
            // 保留退款发票(Credit Invoice)模板
            this.invoiceTemplateList = resData.filter(item => item.invoiceType == 2);
            resolve();
          })
          .catch(err => {
            reject();
          });
      });
    },
    // 获取供应商银行账号列表
    getSupplierBankAccountList() {
      return new Promise((resolve, reject) => {
        this.$http
          .get("/admin/supplierBankAccount")
          .then(res => {
            const resData = res.data || [];
            this.supplierBankAccountList = resData;
            resolve();
          })
          .catch(err => {
            reject();
          });
      });
    },
    // 通过invoiceTemplate匹配相应信息
    invoiceTemplate(id) {
      if (id) {
        const templateName = this.invoiceTemplateList.find(item => item.id == id)?.templateName || "";
        return templateName;
      } else {
        return "";
      }
    },
    // 通过bankAccountIds匹配相应信息
    bankAccountList(ids) {
      if (ids?.length > 0) {
        const list = this.supplierBankAccountList.filter(item => ids.includes(item.id));
        const tagList = list.map(item => item.tag) || [];
        return tagList.join(", ");
      } else {
        return "";
      }
    },
    // 通过bankAccountIds获取开票币种
    billingCurrency(ids) {
      // 第一个银行的币种作为开票币种
      const firstBankAccountId = ids[0];
      const currency = this.supplierBankAccountList.find(item => item.id == firstBankAccountId)?.billingCurrency;
      return currency || "";
    },
  },
};
</script>

<style lang="scss" scoped></style>
